import React from "react";

import Link from "../Link/Link";

const footer = () => {
  return (
    <footer className="">
      <div className="container text-light pt-5 pl-5">
        <div className="row">
          {/* <div className="col-sm-6 col-md-6 mb-5">
            <div className="footer-title">
              <h6>关于我们</h6>
            </div>
            <div className="footer-content">
              <p>
                <small className="text-muted">
                  深圳市洪德茂实业有限公司自2000年成立以来携手世界一流轴
                  承制造商，持续完善供应链管理，以优势品牌为核心，构建高效、
                  多层次、结构完善的产品供应体系，精诚服务国内终端客户和渠
                  道客户，使各种类型客户能够以较低成本获得多元的优质轴承供
                  应和专业的服务支持。
                  深圳市洪德茂实业有限公司是UBC轴承中国一级代理商，AXPB直
                  线导轨中国一级代理商，KML中国一级代理商，同时兼营SKF、FAG、
                  NSK、NTN、NICHI、IKO、KOYO、EASE、IJK、INA、ASAHI、FYH等
                  国内外知名品牌轴承，以及导轨滑块，光轴、油脂、轴承油封配
                  件等。
                </small>
              </p>
              <button className="btn btn-sm btn-primary rounded-0">
                了解更多
              </button>
            </div>
          </div> */}

          <div className="col-sm-6 col-md-6 mb-5">
            <div className="footer-title">
              <h6>联系我们</h6>
            </div>
            <div className="footer-content">
              <p className="text-muted">
                <small>地址 : 广东省深圳市龙岗区龙东鸿景春天103-39</small>
              </p>
              <p className="text-muted">
                <small>门市电话 : 0755-84830378</small>
              </p>
              <p className="text-muted">
                <small>电话 : 13714818078</small>
              </p>
              {/* <div className="social-media mt-4">
                <a href="!#" className="text-light">
                  <i className="fab fa-facebook-f mr-4" />
                </a>
                <a href="!#" className="text-light">
                  <i className="fab fa-twitter mr-4" />
                </a>
                <a href="!#" className="text-light">
                  <i className="fab fa-instagram mr-4" />
                </a>
                <a href="!#" className="text-light">
                  <i className="fab fa-github" />
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-footer pt-3 pb-3 text-center">
        <small>© All Right Reserved. Made By Jaythan.</small>
      </div>
    </footer>
  );
};

export default footer;
